import * as T from './loyaltyProgramTypes';
import type {
  CreateProgramPayload,
  UpdateProgramPayload,
  UpdateSpecialRewardsPayload,
} from '../../../services/loyaltyProgramApi';

export const fetchLoyaltyProgramRequest = () => ({
  type: T.FETCH_LOYALTY_PROGRAM_REQUEST as typeof T.FETCH_LOYALTY_PROGRAM_REQUEST,
});

export const fetchLoyaltyProgramSuccess = (data: any) => ({
  type: T.FETCH_LOYALTY_PROGRAM_SUCCESS as typeof T.FETCH_LOYALTY_PROGRAM_SUCCESS,
  payload: data,
});

export const fetchLoyaltyProgramFailure = (error: string) => ({
  type: T.FETCH_LOYALTY_PROGRAM_FAILURE as typeof T.FETCH_LOYALTY_PROGRAM_FAILURE,
  payload: error,
});

export const createLoyaltyProgramRequest = (payload: CreateProgramPayload) => ({
  type: T.CREATE_LOYALTY_PROGRAM_REQUEST as typeof T.CREATE_LOYALTY_PROGRAM_REQUEST,
  payload,
});

export const createLoyaltyProgramSuccess = (data: any) => ({
  type: T.CREATE_LOYALTY_PROGRAM_SUCCESS as typeof T.CREATE_LOYALTY_PROGRAM_SUCCESS,
  payload: data,
});

export const createLoyaltyProgramFailure = (error: string) => ({
  type: T.CREATE_LOYALTY_PROGRAM_FAILURE as typeof T.CREATE_LOYALTY_PROGRAM_FAILURE,
  payload: error,
});

export const updateLoyaltyProgramRequest = (payload: UpdateProgramPayload) => ({
  type: T.UPDATE_LOYALTY_PROGRAM_REQUEST as typeof T.UPDATE_LOYALTY_PROGRAM_REQUEST,
  payload,
});

export const updateLoyaltyProgramSuccess = (data: any) => ({
  type: T.UPDATE_LOYALTY_PROGRAM_SUCCESS as typeof T.UPDATE_LOYALTY_PROGRAM_SUCCESS,
  payload: data,
});

export const updateLoyaltyProgramFailure = (error: string) => ({
  type: T.UPDATE_LOYALTY_PROGRAM_FAILURE as typeof T.UPDATE_LOYALTY_PROGRAM_FAILURE,
  payload: error,
});

export const updateLoyaltyProgramStatusRequest = (action: 'activate' | 'pause' | 'resume') => ({
  type:
    T.UPDATE_LOYALTY_PROGRAM_STATUS_REQUEST as typeof T.UPDATE_LOYALTY_PROGRAM_STATUS_REQUEST,
  payload: action,
});

export const updateLoyaltyProgramStatusSuccess = (data: any) => ({
  type:
    T.UPDATE_LOYALTY_PROGRAM_STATUS_SUCCESS as typeof T.UPDATE_LOYALTY_PROGRAM_STATUS_SUCCESS,
  payload: data,
});

export const updateLoyaltyProgramStatusFailure = (error: string) => ({
  type:
    T.UPDATE_LOYALTY_PROGRAM_STATUS_FAILURE as typeof T.UPDATE_LOYALTY_PROGRAM_STATUS_FAILURE,
  payload: error,
});

export const fetchLoyaltyAccrualConfigRequest = () => ({
  type: T.FETCH_LOYALTY_ACCRUAL_CONFIG_REQUEST as typeof T.FETCH_LOYALTY_ACCRUAL_CONFIG_REQUEST,
});

export const fetchLoyaltyAccrualConfigSuccess = (data: any) => ({
  type: T.FETCH_LOYALTY_ACCRUAL_CONFIG_SUCCESS as typeof T.FETCH_LOYALTY_ACCRUAL_CONFIG_SUCCESS,
  payload: data,
});

export const fetchLoyaltyAccrualConfigFailure = (error: string) => ({
  type: T.FETCH_LOYALTY_ACCRUAL_CONFIG_FAILURE as typeof T.FETCH_LOYALTY_ACCRUAL_CONFIG_FAILURE,
  payload: error,
});

export const updateLoyaltyAccrualConfigRequest = (payload: Record<string, any>) => ({
  type:
    T.UPDATE_LOYALTY_ACCRUAL_CONFIG_REQUEST as typeof T.UPDATE_LOYALTY_ACCRUAL_CONFIG_REQUEST,
  payload,
});

export const updateLoyaltyAccrualConfigSuccess = (data: any) => ({
  type:
    T.UPDATE_LOYALTY_ACCRUAL_CONFIG_SUCCESS as typeof T.UPDATE_LOYALTY_ACCRUAL_CONFIG_SUCCESS,
  payload: data,
});

export const updateLoyaltyAccrualConfigFailure = (error: string) => ({
  type:
    T.UPDATE_LOYALTY_ACCRUAL_CONFIG_FAILURE as typeof T.UPDATE_LOYALTY_ACCRUAL_CONFIG_FAILURE,
  payload: error,
});

export const fetchLoyaltySpecialRewardsRequest = () => ({
  type:
    T.FETCH_LOYALTY_SPECIAL_REWARDS_REQUEST as typeof T.FETCH_LOYALTY_SPECIAL_REWARDS_REQUEST,
});

export const fetchLoyaltySpecialRewardsSuccess = (data: any) => ({
  type:
    T.FETCH_LOYALTY_SPECIAL_REWARDS_SUCCESS as typeof T.FETCH_LOYALTY_SPECIAL_REWARDS_SUCCESS,
  payload: data,
});

export const fetchLoyaltySpecialRewardsFailure = (error: string) => ({
  type:
    T.FETCH_LOYALTY_SPECIAL_REWARDS_FAILURE as typeof T.FETCH_LOYALTY_SPECIAL_REWARDS_FAILURE,
  payload: error,
});

export const updateLoyaltySpecialRewardsRequest = (payload: UpdateSpecialRewardsPayload) => ({
  type:
    T.UPDATE_LOYALTY_SPECIAL_REWARDS_REQUEST as typeof T.UPDATE_LOYALTY_SPECIAL_REWARDS_REQUEST,
  payload,
});

export const updateLoyaltySpecialRewardsSuccess = (data: any) => ({
  type:
    T.UPDATE_LOYALTY_SPECIAL_REWARDS_SUCCESS as typeof T.UPDATE_LOYALTY_SPECIAL_REWARDS_SUCCESS,
  payload: data,
});

export const updateLoyaltySpecialRewardsFailure = (error: string) => ({
  type:
    T.UPDATE_LOYALTY_SPECIAL_REWARDS_FAILURE as typeof T.UPDATE_LOYALTY_SPECIAL_REWARDS_FAILURE,
  payload: error,
});

export const clearLoyaltyProgramError = () => ({
  type: T.CLEAR_LOYALTY_PROGRAM_ERROR as typeof T.CLEAR_LOYALTY_PROGRAM_ERROR,
});

export const setSetupComplete = (value: boolean) => ({
  type: T.SET_SETUP_COMPLETE as typeof T.SET_SETUP_COMPLETE,
  payload: value,
});

export const updateProgramLocal = (updates: Record<string, any>) => ({
  type: T.UPDATE_PROGRAM_LOCAL as typeof T.UPDATE_PROGRAM_LOCAL,
  payload: updates,
});

export const toggleProgramStatus = () => ({
  type: T.TOGGLE_PROGRAM_STATUS as typeof T.TOGGLE_PROGRAM_STATUS,
});

export const addItemRule = (rule: Record<string, any>) => ({
  type: T.ADD_ITEM_RULE as typeof T.ADD_ITEM_RULE,
  payload: rule,
});

export const updateItemRule = (id: string, updates: Record<string, any>) => ({
  type: T.UPDATE_ITEM_RULE as typeof T.UPDATE_ITEM_RULE,
  payload: { id, updates },
});

export const removeItemRule = (id: string) => ({
  type: T.REMOVE_ITEM_RULE as typeof T.REMOVE_ITEM_RULE,
  payload: id,
});

export type LoyaltyProgramAction =
  | ReturnType<typeof fetchLoyaltyProgramRequest>
  | ReturnType<typeof fetchLoyaltyProgramSuccess>
  | ReturnType<typeof fetchLoyaltyProgramFailure>
  | ReturnType<typeof createLoyaltyProgramRequest>
  | ReturnType<typeof createLoyaltyProgramSuccess>
  | ReturnType<typeof createLoyaltyProgramFailure>
  | ReturnType<typeof updateLoyaltyProgramRequest>
  | ReturnType<typeof updateLoyaltyProgramSuccess>
  | ReturnType<typeof updateLoyaltyProgramFailure>
  | ReturnType<typeof updateLoyaltyProgramStatusRequest>
  | ReturnType<typeof updateLoyaltyProgramStatusSuccess>
  | ReturnType<typeof updateLoyaltyProgramStatusFailure>
  | ReturnType<typeof fetchLoyaltyAccrualConfigRequest>
  | ReturnType<typeof fetchLoyaltyAccrualConfigSuccess>
  | ReturnType<typeof fetchLoyaltyAccrualConfigFailure>
  | ReturnType<typeof updateLoyaltyAccrualConfigRequest>
  | ReturnType<typeof updateLoyaltyAccrualConfigSuccess>
  | ReturnType<typeof updateLoyaltyAccrualConfigFailure>
  | ReturnType<typeof fetchLoyaltySpecialRewardsRequest>
  | ReturnType<typeof fetchLoyaltySpecialRewardsSuccess>
  | ReturnType<typeof fetchLoyaltySpecialRewardsFailure>
  | ReturnType<typeof updateLoyaltySpecialRewardsRequest>
  | ReturnType<typeof updateLoyaltySpecialRewardsSuccess>
  | ReturnType<typeof updateLoyaltySpecialRewardsFailure>
  | ReturnType<typeof clearLoyaltyProgramError>
  | ReturnType<typeof setSetupComplete>
  | ReturnType<typeof updateProgramLocal>
  | ReturnType<typeof toggleProgramStatus>
  | ReturnType<typeof addItemRule>
  | ReturnType<typeof updateItemRule>
  | ReturnType<typeof removeItemRule>;
